import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { mediaMax } from '../../../constants/breakpoints'

interface WallpaperProps {
  src: string
  children?: ReactNode
  className?: string
}

const Wallpaper: React.FC<WallpaperProps> = ({ src, children, className }) => (
  <BackgroundImage className={`room-wallpaper ${className}`} src={src}>
    {children}
  </BackgroundImage>
)

export default Wallpaper

interface BackgroundImageProps {
  src: string
}

const BackgroundImage = styled.div<BackgroundImageProps>`
  background-image: url(${({ src }) => src});
  height: 100%;
  width: 100%;

  background-size: contain;
  background-repeat: repeat-x;
  background-position: right;
  position: absolute;

  @media ${mediaMax.mobileL} {
    background-size: cover;
  }

  /* Remove flashing images */
  /* transform: translate3d(0px, 0px, 1px); */
`

export const WallpaperBack = styled(Wallpaper)`
  background-size: auto 100%;
  background-repeat: repeat-x;
  background-position: left;
  background-position: center;
`

interface WallpaperProps {
  src: string
}

export const WallpaperFloor = styled.div<WallpaperProps>`
  background-size: cover;
  background-image: url(${({ src }) => src});
  /* transform: translate3d(0px, 0px, 1px); */
  filter: brightness(90%);
  height: 100%;
  width: 100%;
`

export const WallpaperTop = styled.div<WallpaperProps>`
  background-image: url(${({ src }) => src});
  /* transform: translate3d(-1px, 0px, 0px); */
  height: 100%;
  width: 100%;
  background-repeat: repeat-x;
  background-position: bottom right;
  background-size: auto 100%;
`

export const WallpaperWindow = styled.div<WallpaperProps>`
  background-image: url(${({ src }) => src});
  height: 100%;
  width: 100%;
  background-repeat: repeat-x;
  background-position: right;
  background-size: cover !important;
  position:absolute;
`

export const WallpaperShadowRight = styled.div`
  position: absolute;
  left:0;
  width:100%;
  height: 100%;
  /* background: linear-gradient(180deg, rgba(173,0,129,0.5) 0%, rgba(79,0, 119,0) 15%); */
`

export const WallpaperShadowLeft = styled.div`
  position: absolute;
  left:0;
  width:100%;
  height: 100%;
  /* background: linear-gradient(0deg, rgba(79,0,119,0) 85%, rgba(173,0,129,0.5) 100%);  */
`

export const WallpaperShadowTopBottom = styled.div`
  position: absolute;
  left:0;
  width:100%;
  height: 100%;
  //background: linear-gradient(0deg,rgba(173,0,129,0) 0%, rgba(79,0,119,1) 100%); 
`
